<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>
    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <img class="user-avatar" src="https://i.loli.net/2021/10/13/rgVtQ4xk5mGzwIO.jpg">
        <span>{{ name }}</span>
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item>
            首页
          </el-dropdown-item>
        </router-link>
<!--        <el-dropdown-item divided>
          <span @click="clickUpdateCurUserPasswd()" style="display:block;">修改密码</span>
        </el-dropdown-item>-->
        <el-dropdown-item divided>
          <span @click="logout" style="display:block;">退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :before-close="handleClose()"
      width="30%">
      <el-form ref="updateCurUserPasswdForm" :model="userPasswd" :rules="rules" label-width="120px">
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input v-model="userPasswd.oldPassword" type="password" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="userPasswd.newPassword" type="password" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="newPassword1">
          <el-input v-model="userPasswd.newPassword1" type="password" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirm('updateCurUserPasswdForm')">确 定</el-button>
      </span>
    </el-dialog>
  </el-menu>
</template>

<script>
import {mapGetters} from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import {updateCurUserPasswd} from "@/api/login";

export default {
  data() {
    return {
      dialogVisible: false,
      dialogTitle: '',
      userPasswd: {
        oldPassword: '',
        newPassword: '',
        newPassword1: '',
      },
      rules: {
        oldPassword: [
          {required: true, message: '请输入旧密码', trigger: 'blur'}
        ],
        newPassword: [
          {required: true, message: '请输入新密码', trigger: 'blur'},
          { min: 6, max: 16, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        newPassword1: [
          {required: true, message: '请输入确认密码', trigger: 'blur'},
          { min: 6, max: 16, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'name'
    ])
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    clickUpdateCurUserPasswd() {
      this.dialogVisible = true;
      this.dialogTitle = "修改密码";
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.userPasswd.newPassword === this.userPasswd.newPassword1) {
            updateCurUserPasswd(this.userPasswd).then(response => {
              this.$message({
                message: '修改成功',
                type: 'success',
                duration: 1000
              });
              this.dialogVisible = false;
            });
          } else {
            this.$message({
              message: '两次输入密码不一致！',
              type: 'error',
              duration: 1000
            });
            return false;
          }
        }
      });
    },
    handleClose() {
      if (!this.dialogVisible && this.$refs.updateCurUserPasswdForm) {
        this.$refs.updateCurUserPasswdForm.clearValidate()
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;

  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }

  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }

  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;

    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;

      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }

      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue